import { BaseModel } from './BaseModel';

export class SwitchGroup extends BaseModel {
    public id = '';
    public name = '';
    public eggsCount?: number;

    getRouteName() {
        return 'switchGroup';
    }

    getRouteID() {
        return this.id.toString();
    }
}
